<div class="stat-card surface-card p-3 border-round h-full">
  <div class="flex align-items-center gap-3">
    <div
      class="flex flex-shrink-0 align-items-center justify-content-center border-round w-3rem h-3rem"
      [class]="'bg-' + color + '-100'">
      <i class="text-xl" [class]="icon + ' text-' + color + '-500'"></i>
    </div>
    <div>
      <span class="block text-500 font-medium mb-1">{{ label }}</span>
      <div class="text-900 font-bold text-xl">{{ value || 0 }}</div>
    </div>
  </div>
</div>
